import {createStyles, Group, Stack} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {ChipSize} from 'ui-library/chips/Chip';
import ProcedureChip from 'ui-library/chips/ProcedureChip';

import {RenderTaskStatusWithIcon} from '../../ProcedureRunTableUtil';
import {UnitOperationFields} from './useUnitOpLinkingState';

const useStyles = createStyles((theme) => ({
  headerContainer: {
    padding: theme.spacing.md,
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
  },
}));

export default function PMEISidepanelHeader({
  unitOperation,
}: {
  unitOperation: UnitOperationFields;
}): JSX.Element {
  const {classes} = useStyles();
  const {procedureId, status} = unitOperation;

  return (
    <Stack
      spacing="xs"
      className={classes.headerContainer}
      {...getTestProps({component: 'PMEISidepanelHeader', element: 'root'})}
    >
      <Group spacing="md" noWrap={true}>
        {procedureId && <ProcedureChip id={procedureId} size={ChipSize.MINI} />}
        {status && (
          <div {...getTestProps({component: 'PMEISidepanelHeader', element: 'status'})}>
            <RenderTaskStatusWithIcon statusType={status} />
          </div>
        )}
      </Group>
    </Stack>
  );
}
